var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMlp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4334_14727)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3028 8.19578L8.69141 8.4305L10.0374 6.37305L10.3028 8.19578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7842 18.3698L10.9734 18.4878L7.43359 11.1225L7.59208 10.8802L10.6292 10.438L11.7842 18.3698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0499 7.64969L12.4384 7.88441L12.168 6.02783L14.0499 7.64969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 9.94496L14.5928 17.9606L13.9206 18.0587L12.7656 10.1265L15.712 9.69727L16.0002 9.94496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9336 9.18551L15.7438 7.88283L12.0373 8.4225L11.6137 5.51221L10.4154 5.68651L10.8393 8.59712L7.13281 9.13679L7.32261 10.4395L11.0291 9.89979L12.2527 18.3014L13.4507 18.1268L12.2271 9.72518L15.9336 9.18551Z",
    fill: "#03F5AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4334_14727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlp);
export default __webpack_public_path__ + "static/media/mlp.e5f9b3de05097eceba0dcf022d025e37.svg";
export { ForwardRef as ReactComponent };